var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"aside"},[_vm._t("aside")],2),_c('div',{staticClass:"main"},[_c('div',{staticClass:"nav"},[_vm._t("nav")],2),_c('div',{staticClass:"content"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }